export const data = {
    experience : [
        {
            title: "Software Developer",
            // subTitle:"Miami,Fl",
            description:"Tudip Technologies",
            date:"Sept 2025 -- Present",
        },
        {
            title: "Frontend Developer Intern",
            // subTitle:"Miami,Fl",
            description:"Prodloop",
            date:"Aug 2024 -- Sept 2024",
        },
        {
            title: "Summer Reaserch Inten",
            // subTitle:"Miami,Fl",
            description:"National Institude of Technology Durgapur",
            date:"May,2023 -- July,2023",
        },
    ],
    education : [
        {
            title: "B-Tech :",
            subTitle:"National Institude of Technology ,Durgapur",
            description:"Bachelor of Technology in Matellurgical and Materials Engineering",
            date : "2021--2025"
        },
        {
            title: "Higher-Secondary :",
            subTitle:"Balurghat High School",
            description:"12th Grade",
            date : "July, 2020"
        },
        {
            title: "Secondary :",
            subTitle:"Balurghat High School",
            description:"10th Grade",
            date : "June, 2018"
        }
    ]
}